import { Component, OnInit } from "@angular/core";
import { CommonUtilService } from "../core/services/common-util-service";
import { Router } from "@angular/router";

@Component({
  selector: "app-ai-modal",
  templateUrl: "./ai-modal.component.html",
  styleUrls: ["./ai-modal.component.scss"],
})
export class AiModalComponent implements OnInit {
  constructor(private commonUtilService: CommonUtilService,private router:Router) {}

  ngOnInit(): void {}

  messages: {
    role: "user-ai" | "bot-ai";
    content: string;
    type: string;
    data: any;
  }[] = [
    {
      role: "bot-ai",
      data: [],
      type: "text",
      content: "Hi! How can I help you today?",
    },
  ];

  userInput: string = "";

  async sendMessage() {
    if (!this.userInput.trim()) return;

    try {
      let obj = {
        skill: this.userInput,
      };
      this.messages.push({
        role: "user-ai",
        type: "text",
        data: [],
        content: this.userInput,
      });

      const res: any = await this.commonUtilService.askAiStaff(obj);
      if (res && res.length > 0) {
        res.forEach(el => {
          el.functionNames.toString()
        })
        this.messages.push({
          role: "bot-ai",
          data: res,
          type: "list",
          content: "",
        });
      } else {
        this.messages.push({
          role: "bot-ai",
          type: "text",
          data: [],
          content: `No entries found`,
        });
      }

      this.userInput = "";
    } catch (error) {
      console.log(error);
    }
  }

    redirectToResource(row) {
      let routeUrl = "/teamium/personal/staff-details/" + row;
      const url = this.router.serializeUrl(this.router.createUrlTree([routeUrl]));
      window.open(url, "_blank");
  }
}
